export default __webpack_public_path__ + "static/media/4.7ffa95d8.jpg";